export default "__VITE_ASSET__DW_2LHUk__"